// extracted by mini-css-extract-plugin
export var who = "home-module--who--2imvm";
export var whocontact = "home-module--whocontact--3FzHj";
export var quote = "home-module--quote--2aWcq";
export var areas = "home-module--areas--cpvLY";